import { atom } from "recoil";

export const collectionPointSearchAtom = atom({
    key: "collectionPointSearch",
    default: ""
})
